import { useParams } from 'react-router-dom';

import { useTenantIdFromSession } from './useSession';

export const useTenantIdFromParams = () => {
  const { tenantId } = useParams() as { tenantId: string | undefined };
  return tenantId;
};

/**
 * Tenant resolution for components mounted under BOTH `:tenantId` routes and
 * tenantless routes (e.g. output-template pages, which render under
 * `/organizations/:tenantId/settings/templates` AND `/admin/output-templates`).
 *
 * Route tenant wins when present — since ENG-5545 the shared session claim no
 * longer tracks the tenant a tab is on. On tenantless routes this falls back
 * to the session tenant (the tenant-scoped minted claims under a TenantGuard,
 * the shared claim elsewhere — the pre-ENG-5545 behavior those routes had).
 */
export const useTenantIdFromParamsOrSession = (): string | undefined => {
  const routeTenantId = useTenantIdFromParams();
  const sessionTenantId = useTenantIdFromSession();
  return routeTenantId ?? sessionTenantId;
};

/**
 * Assumes that there will definitely be a tenantId in the URL params.
 * This hook is safe to use if you know you're in a :tenantId route
 */
export const useAssignedTenantIdFromParams = () => {
  const { tenantId } = useParams() as { tenantId: string };
  return tenantId;
};
